import { match as matcher } from "path-to-regexp";
import React from "react";
export function extractPathFromSearchParams(currentPath, pathParam) {
	const searchParams = new URLSearchParams(currentPath);
	return searchParams.get(pathParam) || "/";
}

export function matchRoutes(children, location) {
	const matches = [];

	React.Children.forEach(children, (route) => {
		const fn = matcher(route.props.path, { decode: decodeURIComponent });
		const match = fn(location);

		if (match) {
			const params = match.params;

			matches.push({
				component: route.props.component,
				params: params,
			});
		}
	});
	return matches[0];
}

export function extractParams(queryParams, pathParam) {
	const params = new URLSearchParams(queryParams);
	params.delete(pathParam);

	const paramObj = {};
	for (const value of params.keys()) {
		paramObj[value] = params.get(value);
	}

	return paramObj;
}
